export const setLanguageHandler = (language: any, dispatch: any) => {
  dispatch({
    type: "SET_LANGUAGE",
    payload: language,
  });
};